import isIPFS from 'is-ipfs'

export const getIsIPFS = (url: string) => {
  return (
    url.includes('ipfs.io') || url.includes('images.nf.domains/ipfs') || url.includes('ipfs://')
  )
}

export const getIPFSUrl = (url: string) => {
  if (url.startsWith('https://images.nf.domains/ipfs/')) {
    return url.replace('https://images.nf.domains/ipfs/', 'https://ipfs.io/ipfs/')
  }

  if (url.startsWith('ipfs://')) {
    return url.replace('ipfs://', 'https://ipfs.io/ipfs/')
  }

  return url
}

export const isValidIpfsUrl = (url: string, isGatewayUrl = false) => {
  if (isGatewayUrl) {
    return isIPFS.url(url)
  }

  const isIpfs = url.startsWith('ipfs://')
  if (isIpfs) {
    const gatewayUrl = url.replace('ipfs://', 'https://ipfs.io/ipfs/')
    return isIPFS.url(gatewayUrl)
  }

  return false
}
